<template>
  <el-tree
    class="org-dep-tree"
    node-key="department_id"
    ref="tree"
    lazy
    highlight-current
    :data="treeList"
    :props="treeProps"
    :load="loadNode"
    :accordion="true"
    :default-expanded-keys="defaultExpandedKeys"
    :expand-on-click-node="false"
    @node-click="handleNodeClick"
  >
  </el-tree>
</template>

<script>
import { depListFn, orgInfoFn } from 'api/org/dep'
export default {
  data() {
    return {
      defaultExpandedKeys: [],
      treeList: [],
      treeProps: {
        label: 'department_name',
        isLeaf: 'is_sub_department'
      }
    }
  },
  mounted() {
    this.getOrgInfo()
  },
  methods: {
    async getOrgInfo() {
      this.treeList = []
      const res = await orgInfoFn()
      if (res && res.code === 1) {
        this.defaultExpandedKeys = [Number(res.data.id)]
        this.treeList.push({
          is_sub_department: false,
          department_name: res.data.department_name,
          department_id: Number(res.data.id),
          supervisor_id: res.data.supervisor_id,
          supervisor_name: res.data.supervisor_name
        })
      }
    },
    loadNode(node, resolve) {
      if (node.data.department_id) {
        depListFn({ department_id: node.data.department_id }).then(res => {
          this.tableData = res.data
          resolve(
            res.data.map(v => ({
              department_name: v.department_name,
              department_id: Number(v.department_id),
              is_sub_department: !v.is_sub_department,
              supervisor_id: v.supervisor_id,
              supervisor_name: v.supervisor_name
            }))
          )
        })
      }
    },
    handleNodeClick(val, Node) {
      this.$emit('node-click', val, Node)
    }
  }
}
</script>
